// Expliziter Ruecksprung zur Bestätigungsseite (profil-bestaetigen):
// NUR deren Edit-Stifte haengen ?returnTo=<bestätigungsseite> an die
// Frage-Seiten. Kunden mitten im normalen Flow haben den Parameter nie in
// der URL — fuer sie aendert sich das Routing dadurch garantiert nicht.
// (Bewusst KEIN sessionStorage o.ä.: nur die aktuelle URL zaehlt, damit ein
// spaeterer Besuch ohne returnTo niemals faelschlich zur Bestaetigung leitet.)
export function getConfirmationReturnTo(id) {
  if (typeof window === "undefined") return null;
  const raw =
    new URLSearchParams(window.location.search).get("returnTo") || "";
  return raw.startsWith(`/${id}/`) ? raw : null;
}
